import { aboutData } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-information-line"></i>
              平台介绍
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              关于51吃瓜网
            </h2>
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full max-w-[560px] lg:max-w-none">
              <div className="rounded-2xl overflow-hidden shadow-md">
                <img
                  src={aboutData.image}
                  alt="51吃瓜网平台介绍 - 专业编辑团队7x24小时追踪娱乐圈动态"
                  title="51吃瓜网平台 - 专业编辑团队"
                  className="w-full h-auto object-cover"
                  width="800"
                  height="500"
                />
              </div>
            </div>
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
                {aboutData.description}
              </p>
              <div className="grid grid-cols-3 gap-4">
                {aboutData.stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70"
                  >
                    <div className="text-xl md:text-2xl font-heading font-bold text-primary-500 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}